import React from 'react';
import './anim.css'
const batmanImage = '/images/batman.png';
const cheneyImage = '/images/cheney.png';
const mansonImage = '/images/manson.png';
const patrickImage = '/images/patrick.png';
const reznikImage = '/images/reznik.png';
const specialImage = '/images/special.png';

const characterImages = [
  batmanImage,
  cheneyImage,
  mansonImage,
  patrickImage,
  reznikImage,
  specialImage,
];

const CharacterCarousel = () => {
    return (
      <div className="character-carousel">
        {characterImages.map((image, index) => (
          <div
            key={index}
            className="character-image"
            style={{
              backgroundImage: `url(${image})`,
              opacity:1.0
            }}
          ></div>
        ))}
      </div>
    );
  };
  
  export default CharacterCarousel;